var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNews = function SvgNews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "fi_9511348",
    width: 512,
    height: 512,
    fill: "currentColor",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.879 15.087H7.002A3.01 3.01 0 0 0 4 18.09V32.83a3.01 3.01 0 0 0 3.002 3.002h8.877zM49.954 6.911c-1.112-.546-2.41-.328-3.322.48-6.087 4.973-13.9 7.72-21.746 7.696H17.88v20.745h7.006c7.89-.033 15.617 2.734 21.796 7.736 1.85 1.666 5.068.243 4.983-2.272V9.623c0-1.17-.65-2.212-1.71-2.712M53.667 17.599V33.31c8.446-1.914 8.442-13.8 0-15.712M22.224 37.834h-11.69l7.747 17.143a4.1 4.1 0 0 0 3.732 2.412c2.603.069 4.69-2.627 3.963-5.134z"
  })));
};
export default SvgNews;